module.exports = __webpack_public_path__ + "static/top-1dc52e3cb4bfb4c78b4786e0a23217cc.png";